module.exports = __webpack_public_path__ + "img/avata2.9965fdd1.png";